(function () {
  // Server-side routes to exclude
  var serverRoutes = [
    "/category",
    "/categories",
    "/cf-login-error",
    "/users",
    "/tags",
    "/account",
    "/admin",
    "/affiliate",
    // NOT "/affiliates": that page IS the SPA (affiliates state); a reload
    // rule for it would boot the shell into an infinite reload loop.
    "/terms",
    "/privacy-policy",
    "/cookie-policy",
    "/licensing",
    // the UI8 MCP landing page (server-rendered; without this the "/{id}"
    // author state takes it for a username and shows the user 404)
    "/mcp",
  ];

  // Define UI8 Application
  angular
    .module("UI8SPA", [
      "ngResource",
      "ngCookies",
      "express-csrf",
      "ui.router",
      "UI8.filters",
      "UI8.services",
      "UI8.resources",
      "UI8.directives",
      "UI8.controllers",
      "UI8.components",
      "credit-cards",
      "ngFileUpload",
      "relativeDate",
      "ngSanitize",
    ])
    .config([
      "$locationProvider",
      function ($locationProvider) {
        $locationProvider.html5Mode(true);
      },
    ])
    .config(function ($httpProvider) {
      $httpProvider.defaults.headers.common["X-Requested-With"] =
        "XMLHttpRequest";
      $httpProvider.defaults.withCredentials = true;
    })
    // Registered BEFORE the states: ui-router matches URL rules in
    // registration order, and the authorPage state's "/{id}" catch-all
    // would otherwise swallow server-rendered paths like /terms and
    // /privacy-policy, rendering the SPA's user-404 instead of the page.
    .config(function ($urlRouterProvider) {
      $urlRouterProvider.when("/category/all", "/category/featured-products");
      $urlRouterProvider.when("/categories/all", "/category/featured-products");
      $urlRouterProvider.when(
        "/category/top-products",
        "/category/featured-products"
      );
      $urlRouterProvider.when(
        "/categories/top-products",
        "/category/featured-products"
      );
      $urlRouterProvider.when(
        "/categories/featured-products",
        "/category/featured-products"
      );
      $urlRouterProvider.when(
        "/products/ultimate-pass",
        "/products/all-access-pass"
      );
      $urlRouterProvider.when(
        "/product/ultimate-pass",
        "/products/all-access-pass"
      );
      $urlRouterProvider.when(
        "/product/unlimited-pass",
        "/products/all-access-pass"
      );
      $urlRouterProvider.when(
        "/product/ui8/all-access-pass",
        "/products/all-access-pass"
      );
      $urlRouterProvider.when(
        "/products/ui8/all-access-pass",
        "/products/all-access-pass"
      );
      $urlRouterProvider.when("/account", "/account/purchases");
      for (var i = 0; i < serverRoutes.length; i++) {
        var serverPath = serverRoutes[i];
        $urlRouterProvider.when(serverPath, function () {
          location.reload();
        });
      }
      $urlRouterProvider.otherwise(function () {
        location.reload();
      });
    })
    .config(function ($stateProvider) {
      var home = {
        name: "home",
        url: "^/",
        component: "home",
        resolve: {
          data: function (ProductService) {
            return ProductService.homeDigest();
          },
          user: function (SessionService) {
            return SessionService.user();
          },
          featuredAuthorProducts: function (ProductService) {
            return ProductService.featuredAuthorProducts();
          },
        },
        onEnter: revealPage,
      };

      var ai = {
        name: "dna",
        url: "^/dna",
        component: "ai",
        resolve: {
          dnaProducts: function (ProductService) {
            return ProductService.list({ hasDesignDna: true, count: 12 });
          },
        },
        onEnter: revealPage,
      };

      var login = {
        name: "accountLogin",
        url: "^/account/login",
        component: "accountLogin",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: function (user) {
          if (user) return (window.location = "/account");
          revealPage();
        },
      };

      var signup = {
        name: "accountSignup",
        url: "^/account/signup",
        component: "accountSignup",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: function (user) {
          if (user) return (window.location = "/account");
          revealPage();
        },
      };

      var forgot = {
        name: "accountForgot",
        url: "^/account/forgot",
        component: "accountForgot",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: function (user) {
          if (user) return (window.location = "/account");
          revealPage();
        },
      };

      var authors = {
        name: "openShop",
        url: "^/authors",
        component: "openShop",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: scrollTopAndReveal,
      };

      var affiliates = {
        name: "Affiliates",
        url: "^/affiliates",
        component: "affiliates",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: scrollTopAndReveal,
      };

      // Unlisted Framer landing page (UI8-9). Not linked from anywhere on the
      // site; reachable from a Google ad or by typing the path. Shares the
      // /api/pass payload with `pass`, so tiers, prices and the current sale
      // stay in lockstep with the real page. Declared before `pass` so the
      // more specific path is matched first.
      var framerPass = {
        name: "framerPass",
        url: "^/products/all-access-pass/framer",
        component: "framerPassDetails",
        resolve: {
          data: function (ProductService) {
            return ProductService.passPage();
          },
          // Already ranked and narrowed server-side, refreshed weekly.
          products: function (ProductService) {
            return ProductService.framerPicks();
          },
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: revealPage,
      };

      var pass = {
        name: "pass",
        url: "^/products/all-access-pass",
        component: "productPage",
        resolve: {
          data: function (ProductService) {
            console.log("app_spa -> product page data");
            return ProductService.passPage();
          },
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: revealPage,
      };

      var sale = {
        name: "sale",
        url: "^/sale",
        component: "category",
        resolve: {
          data: function (CategoryService) {
            var page = sessionStorage.getItem("page:sale") || 1;
            return CategoryService.findBySlug("sale", {
              page: page,
              ff: page > 1 ? true : false,
            });
          },
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: revealPage,
      };

      var trending = {
        name: "trending",
        url: "^/trending",
        component: "category",
        resolve: {
          data: function (CategoryService) {
            var page = sessionStorage.getItem("page:sale") || 1;
            return CategoryService.findBySlug("trending", {
              page: page,
              ff: page > 1 ? true : false,
            });
          },
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: revealPage,
      };

      var featuredProducts = {
        name: "topProducts",
        url: "^/category/featured-products",
        component: "featuredEditorial",
        resolve: {
          data: function (CategoryService) {
            return CategoryService.findBySlug("featured-products", {});
          },
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: scrollTopAndReveal,
      };

      var categories = {
        name: "categories",
        url: "/categories/{slug}",
        component: "category",
        resolve: {
          data: function (CategoryService, $transition$) {
            var slug = $transition$.params().slug;
            var page = sessionStorage.getItem("page:" + slug) || 1;
            return CategoryService.findBySlug(slug, {
              page: page,
              ff: page > 1 ? true : false,
            });
          },
          user: function (SessionService) {
            return SessionService.user();
          },
        },
      };

      var category = {
        name: "category",
        url: "/category/{slug}",
        component: "category",
        resolve: {
          data: function (CategoryService, $transition$) {
            var slug = $transition$.params().slug;
            var page = sessionStorage.getItem("page:" + slug) || 1;
            return CategoryService.findBySlug(slug, {
              page: page,
              ff: page > 1 ? true : false,
            });
          },
          user: function (SessionService) {
            return SessionService.user();
          },
        },
      };

      var purchases = {
        name: "purchases",
        url: "^/account/purchases",
        component: "accountPurchases",
        resolve: {
          data: function (SessionService) {
            return SessionService.purchases();
          },
        },
        onEnter: function (data) {
          if (!data.user)
            return (window.location = "/account/login?from=_account_purchases");
          scrollTopAndReveal();
        },
      };

      // Hire inbox (UI8-16)
      var inbox = {
        name: "inbox",
        url: "^/account/inbox",
        component: "inboxList",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: function (user) {
          if (!user)
            return (window.location = "/account/login?from=_account_inbox");
          scrollTopAndReveal();
        },
      };

      var inboxThread = {
        name: "inboxThread",
        url: "^/account/inbox/{id}",
        component: "inboxThread",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
          threadId: function ($transition$) {
            return $transition$.params().id;
          },
        },
        onEnter: function (user) {
          if (!user)
            return (window.location = "/account/login?from=_account_inbox");
          scrollTopAndReveal();
        },
      };

      // Hire directory (UI8-16, dark until the UI8-15 reveal)
      var shotsHire = {
        name: "shotsHire",
        url: "^/shots/hire",
        component: "hireDirectory",
        onEnter: scrollTopAndReveal,
      };

      var favorites = {
        name: "favorites",
        url: "^/favorites",
        component: "favorites",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
          data: function (FavoriteService) {
            return FavoriteService.list(1);
          },
        },
        onEnter: function (user) {
          if (!user)
            return (window.location = "/account/login?from=_favorites");
          scrollTopAndReveal();
        },
      };

      // Shots (UI8-13). Registered before the authorPage "/{id}" catch-all
      // so /shots isn't swallowed as a profile slug. The detail page
      // /shots/:slug is server-rendered — no state, the otherwise() rule
      // reloads into it.
      var shotsNew = {
        name: "shotsNew",
        url: "^/shots/new",
        component: "shotComposer",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
          permissions: function (ShotService) {
            return ShotService.permissions();
          },
        },
        onEnter: function (user) {
          if (!user) return (window.location = "/account/login?from=_shots");
          scrollTopAndReveal();
        },
      };

      var shotsEdit = {
        name: "shotsEdit",
        url: "^/shots/{slug}/edit",
        component: "shotComposer",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
          permissions: function (ShotService) {
            return ShotService.permissions();
          },
          shot: function (ShotService, $transition$) {
            return ShotService.get($transition$.params().slug);
          },
        },
        onEnter: function (user) {
          if (!user) return (window.location = "/account/login?from=_shots");
          scrollTopAndReveal();
        },
      };

      var shots = {
        name: "shots",
        url: "^/shots",
        component: "shots",
        resolve: {
          user: function (SessionService) {
            return SessionService.user();
          },
          data: function (ShotService) {
            return ShotService.list({ page: 1, sort: "recent" });
          },
        },
        onEnter: scrollTopAndReveal,
      };

      var profile = {
        name: "profile",
        url: "/users/{id}",
        component: "userProfile",
        resolve: {
          data: function (UserService, $transition$) {
            return UserService.show($transition$.params().id);
          },
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: scrollTopAndReveal,
      };

      var authorProfile = {
        name: "authorProfile",
        url: "/{id}/products",
        component: "userProfile",
        resolve: {
          data: function (UserService, $transition$) {
            return UserService.show($transition$.params().id);
          },
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: scrollTopAndReveal,
      };

      var authorPage = {
        name: "authorPage",
        url: "/{id}",
        component: "userProfile",
        resolve: {
          data: function (UserService, $transition$) {
            return UserService.show($transition$.params().id);
          },
          user: function (SessionService) {
            return SessionService.user();
          },
        },
        onEnter: scrollTopAndReveal,
      };

      var userSettings = {
        name: "userSettings",
        url: "^/account/settings",
        component: "accountSettings",
        resolve: {
          data: function (AccountService) {
            return AccountService.settings();
          },
        },
        onEnter: function (data) {
          if (!data.user)
            return (window.location = "/account/login?from=_account_settings");
          scrollTopAndReveal();
        },
      };

      $stateProvider
        .state(home)
        .state(ai)
        .state(login)
        .state(signup)
        .state(forgot)
        .state(authors)
        .state(affiliates)
        .state(framerPass)
        .state(pass)
        .state(sale)
        .state(trending)
        .state(featuredProducts)
        .state(category)
        .state(categories)
        .state(purchases)
        .state(favorites)
        .state(inbox)
        .state(inboxThread)
        .state(shotsNew)
        .state(shotsHire)
        .state(shotsEdit)
        .state(shots)
        .state(authorProfile)
        .state(profile)
        .state(userSettings)
        .state(authorPage);

      function scrollToTop() {
        window.scrollTo(0, 0);
      }

      function revealPage() {
        angular
          .element(document.querySelector(".page-loader-container"))
          .addClass("ng-hide");
        angular
          .element(document.querySelector(".body-container"))
          .removeClass("ng-hide");
      }

      function scrollTopAndReveal() {
        scrollToTop();
        revealPage();
      }
    })
    .config([
      "$compileProvider",
      function ($compileProvider) {
        $compileProvider.debugInfoEnabled(false);
      },
    ])
    .run(function (
      $rootScope,
      SessionService,
      $transitions,
      $location,
      $timeout
    ) {
      // vendor.min.js is deferred, so the inline UI8 blob in the layout runs
      // before uuidv4 exists; mint the checkout idempotency key here instead.
      if (!window.UI8.idempotencyKey && window.uuidv4)
        window.UI8.idempotencyKey = window.uuidv4();

      if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
      } else {
        window.addEventListener("unload", function () {
          //set scroll position to the top of the page.
          window.scrollTo(0, 0);
        });
      }

      if (!$rootScope.user) {
        SessionService.setCurrentUser();
      }

      function openSearch(letter) {
        $rootScope.showSearch = true;
        if (letter != null) {
          localStorage.removeItem("srch:search-state");
          sessionStorage.removeItem("top:search");
          sessionStorage.removeItem("count:search");
          $rootScope.searchTerm = letter;
        }
        $timeout(function () {
          $rootScope.$digest();
        });
        $location.search("search", 1);
        $("body").css("overflow-y", "hidden");
      }

      window.openSearch = openSearch;

      // While scrolling, product cards ignore the pointer so hover
      // states can't flash as the page moves under the cursor (also
      // skips hover hit-testing/style recalc mid-scroll). Capture
      // catches nested scrollers like the search modal.
      var scrollIdleTimer = null;
      window.addEventListener(
        "scroll",
        function () {
          if (scrollIdleTimer === null)
            document.body.classList.add("is-scrolling");
          clearTimeout(scrollIdleTimer);
          scrollIdleTimer = setTimeout(function () {
            scrollIdleTimer = null;
            document.body.classList.remove("is-scrolling");
          }, 150);
        },
        { passive: true, capture: true }
      );

      document.addEventListener("keydown", function (e) {
        var invalids = ["input", "select", "textarea"];

        if (invalids.indexOf(e.target.nodeName.toLowerCase()) !== -1) return;

        // Type-to-search stays off while the cart drawer is open
        if (document.querySelector(".header__cell--cart.active")) return;

        if ($rootScope.showSearch) {
          $("#search-input").focus();
        }

        // Ignore keypresses when Cmd, Ctrl, or Alt are pressed
        if (e.altKey || e.ctrlKey || e.metaKey) return;

        // Only react to numbers and letters
        if (e.keyCode < 48 || e.keyCode > 90) return;

        var letter = String.fromCharCode(e.keyCode);
        if (!e.shiftKey) letter = letter.toLowerCase();

        if (!$rootScope.showSearch) {
          return openSearch(letter);
        }
      });

      // Drawer links keep the overlay up on click (search-modal.js
      // leaveSearch): a full-page navigation shows it until the next
      // document lands instead of flashing the page underneath. For an
      // in-app transition to another path, hide it here so the new state
      // is not covered by the still-open search.
      var lastPath = null;
      $transitions.onStart({}, function () {
        var path = $location.path();
        if (lastPath !== null && path !== lastPath && $rootScope.showSearch) {
          $rootScope.showSearch = false;
          $("body").css("overflow-y", "scroll");
        }
      });

      $transitions.onSuccess({}, function () {
        lastPath = $location.path();
        if ($location.search().search) openSearch();
        if ($location.search().support && window.$chatwoot)
          window.$chatwoot.toggle("open");
      });

      // bfcache restore fires no transition; if the overlay was hidden
      // (in-app transition) before navigating away, reopen it here.
      window.addEventListener("pageshow", function (e) {
        if (e.persisted && $location.search().search && !$rootScope.showSearch)
          openSearch();
      });
    }); /*.run(function($uiRouter) {
      var Visualizer = window['ui-router-visualizer'].Visualizer;
      var pluginInstance = $uiRouter.plugin(Visualizer);
  });*/

  // Application Namespaces
  angular.module("UI8.filters", []);
  angular.module("UI8.services", []);
  angular.module("UI8.resources", []);
  angular.module("UI8.directives", []);
  angular.module("UI8.controllers", []);
  angular.module("UI8.components", []);
})();
